<template>
  <div>
      <h2 class="mt-5">Upload Target</h2>
     <ExcelVue :sheet="sampleExcel" :fname="filename"/>
 
  </div>
</template>

<script>
import ExcelVue from "@/components/ExcelTarget.vue";

export default {
  components: {
 
    ExcelVue
},
  data() {
    return {
      file: null, 
      filename:"FormTarget.xlsx",
      sampleExcel:[{ 
                    name: "SheetOne",  
                    data: [ 
                            {
                              "admin_hub_code":"ADM-CGK.BRT.03",
                              "ph":"PH Jakarta Barat",
                              "shipment_target":34081,
                              "revenue_target":892314610
                            },
                          ] 
                    }],
    };
  },
  methods: {
    onChange(event) {
      this.file = event.target.files ? event.target.files[0] : null;
    },
    test(){}

  },
  mounted(){
    
  }
 
};
</script>
<style scoped>
input[type="file"] {
    width: 50%;
    border: 1px solid black;
    padding: 5px 25px;
    border-radius: 5px;
}
</style>
